"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaffleEventType = void 0;
var RaffleEventType;
(function (RaffleEventType) {
    RaffleEventType["RoundFinalizedRaffle"] = "RoundFinalizedRaffle";
    RaffleEventType["RoundFinalized"] = "RoundFinalized";
    RaffleEventType["RoundStarted"] = "RoundStarted";
    RaffleEventType["RoundEnded"] = "RoundEnded";
    RaffleEventType["Released"] = "Released";
    RaffleEventType["Prize"] = "Prize";
})(RaffleEventType || (exports.RaffleEventType = RaffleEventType = {}));
//# sourceMappingURL=raffle.js.map